'use strict';

/**
 * JobCredits
 *
 * @type {{index: waApp.controllers.JobCredits.index}}
 */
waApp.controllers.JobCredits = {

	setupPackages: function(form) {
		form.on('change', '#company-id', function(event) {
			let companyId = $(event.target).val();

			$.ajax({
				method: 'POST',
				url: waApp.getLanguage() + '/job-credits/get-packages',
				dataType: 'json',
				data: {
					company_id: companyId
				}
			})
			.done(function(data) {
				let jobpackageInput = $('#job-package-id');

				jobpackageInput.html('');

				$.each(data.packages, function(key, value) {
					jobpackageInput.append('<option value="' + key + '">' + value + '</option>');
				});

				jobpackageInput.trigger('change');
			});
		});
	},

	setupPreview: function(form) {
		form.on('change', '#job-package-id', function(event) {
			let value = $(event.target).val();

			let preview = $('#checkout-preview');

			if (value == null || value == '') {
				preview.html('');

				return;
			}

			let loading = $('#checkout-loading');

			preview.fadeOut('fast', function() {
				loading.fadeIn('fast');
			});

			$.ajax({
				method: 'POST',
				url: waApp.getLanguage() + '/job-credits/checkout-preview',
				data: {
					company_id: $('#company-id').val(),
					job_package_id: value
				}
			})
			.done(function(data) {
				preview.html(data);

				setTimeout(function() {
					loading.fadeOut('slow', function() {
						preview.fadeIn('fast');
					});
				}, 500);
			});
		});
	},

	index: function() {
		let form = $('#job-credit-purchase-form');

		let purchaseButton = $('#purchase-button');

		purchaseButton.on('click', function() {
			if ($('#payment-method-id').val() != 6) {
				$('#credit-card-inputs').remove();
			}

			form.submit();
		});

		waApp.controllers.JobCredits.setupPackages(form);
		waApp.controllers.JobCredits.setupPreview(form);

		let paymentMethodHelper = new PaymentMethodFormHelper(form);

		paymentMethodHelper.initialize();

		let stripeHelper = new StripeFormHelper(form);

		form.on('submit', function(event) {
			// Disable the submit button to prevent repeated clicks
			purchaseButton.prop('disabled', true);

			// Return if payment method is not Stripe
			if ($('#payment-method-id').val() != 6) {
				return true;
			}

			event.preventDefault();

			stripeHelper.createToken();

			// Prevent the form from being submitted
			return false;
		});
	}
};
